export const StaticRouteParameter = {
  AVC_SYSTEM: 'avc-system',
  ACCEPT_INVITATION: 'accept-invitation',
  ACCESS_KEYS: 'access-keys',
  ACCOUNT: 'account',
  ALERTS: 'alerts',
  APPS: 'apps',
  ASSETS: 'assets',
  AUDIO_TRACKS: 'audio-tracks',
  AUDIOS: 'audios',
  AUDIOSTREAMS: 'audiostreams',
  AV: 'av',
  AVC_INSTANCE_TASKS: 'tasks',
  AVC_INSTANCE: 'avc-instances',
  AVC_TASKS_TASKS: 'tasks',
  AVC_TASKS: 'avc-tasks',
  AVIO: 'avio',
  AVOBJECTS: 'avobjects',
  AVSTREAMS: 'avstreams',
  AVTASKS: 'avtasks',
  AZURE: 'azure',
  BLOBS: 'blobs',
  BUNDLES: 'bundles',
  CHANNEL_ENTRIES: 'channelEntries',
  CHANNELS: 'channels',
  CLIPS: 'clips',
  CLUSTERS: 'clusters',
  COLLECTIONS: 'collections',
  CONFIG: 'config',
  CONTENT: 'content',
  CONTENT_FLOWS: 'content-flows',
  CONTENT_REGIONS: 'content-regions',
  CONTENT_STORES: 'content-stores',
  CREATE_TEMPLATE_CONFIGURATION: 'configuration',
  CREATE_TEMPLATE_CREATE_MAPPING: 'create-mapping',
  CREATE_TEMPLATE_VERIFY: 'verify',
  CREATE_TEMPLATE: 'create-template',
  CREDENTIALS: 'credentials',
  DASHBOARD: 'dashboard',
  DATA_PROVIDER: 'data-provider',
  DATA: 'data',
  DATAOBJECTS: 'dataobjects',
  DATASTREAMS: 'datastreams',
  DRM_PROVIDER: 'drm-provider',
  ENTITIES: 'entities',
  ENTRIES: 'entries',
  ENVIRONMENTS: 'environments',
  EVENT_SESSIONS: 'sessions',
  EVENTS: 'events',
  EXP_APPS: 'exp-apps',
  EXP_MANIFESTS: 'exp-manifests',
  EXTERNAL_STORES: 'external-stores',
  FAQ: 'faq',
  GENERAL: 'general',
  GENERIC_CONTENT_STREAMS: 'generic-content-streams',
  GLOBAL_AUDIOS: 'global-audios',
  HARDWARE: 'hardware',
  IMAGES: 'images',
  IMPRINTS: 'imprints',
  INGEST_TASKS: 'ingest-tasks',
  INSTANCES: 'instances',
  INTEGRATIONS: 'integrations',
  INVITATIONS: 'invitations',
  JSON: 'JSON',
  LEGAL: 'legal',
  LINE_CONTEXTS: 'line-contexts',
  LOGS: 'logs',
  LOGOUT: 'logout',
  MANAGE_ACCESS: 'manage-access',
  MANAGED_STORES: 'managed-stores',
  MEDIA_CHANNEL_ENTRIES: 'entries',
  MEDIA_CHANNELS: 'media-channels',
  MEDIA_LIBRARIES: 'media-libraries',
  MEDIA_PLATFORMS: 'media-platforms',
  MEDIAS: 'medias',
  MEMBERS: 'members',
  META: 'meta',
  MOMENTS: 'moments',
  MONITORING: 'monitoring',
  MY: 'my',
  NEW: 'new',
  OAUTH: 'oauth',
  OBJECTS: 'objects',
  OFFERS: 'offers',
  OLD_PROGRAMS: 'old-programs',
  ORG: 'org',
  ORGANIZATIONS: 'organizations',
  ORIGIN_GATEWAYS: 'origin-gateways',
  ORIGINS: 'origins',
  PAGES: 'pages',
  PERMISSIONS: 'permissions',
  PROCESS_INVITATION_AD_REDIRECT: 'process-invitation-ad-redirect',
  PROCESS_INVITATION: 'process-invitation',
  PROGRAM: 'program',
  PROGRAMS: 'programs',
  RAW: 'raw',
  REGIONS: 'regions',
  RESERVATIONS: 'reservations',
  SECTIONS: 'sections',
  SERIES: 'series',
  SETTINGS: 'settings',
  SETUP: 'setup',
  SETUPS: 'setups',
  SHARING: 'sharing',
  SHORTS: 'shorts',
  SHOWCASES: 'showcases',
  SIGN_IN: 'sign-in',
  SPACES: 'spaces',
  STATUS: 'status',
  STREAMS: 'streams',
  TEAMS: 'teams',
  TERMS: 'terms',
  UPLOADS: 'uploads',
  USER: 'user',
  VIDEO_TRACKS: 'video-tracks',
  VIDEOS: 'videos',
  VIDEOSTREAMS: 'videostreams',
  WATCH: 'watch',
  WORKSPACES: 'workspaces',
} as const

export const DynamicRouteParameter = {
  ACCESS_KEY_ID: 'accessKeyId',
  APP_ID: 'appId',
  ASSET_ID: 'assetId',
  AUDIO_TRACK_ID: 'audioTrackId',
  AUDIOOBJECT_ID: 'audioobjectId',
  AUDIOSTREAM_ID: 'audiostreamId',
  AVC_INSTANCE_ID: 'avcInstanceId',
  AVC_INSTANCE_TASK_ID: 'avcInstanceTaskId',
  AVC_TASK_ID: 'avcTaskId',
  AVOBJECT_ID: 'avobjectId',
  AVSTREAM_ID: 'avstreamId',
  BLOB_ID: 'blobId',
  BUNDLE_ID: 'bundleId',
  CHANNEL_ENTRY_ID: 'channelEntryId',
  CHANNEL_ID: 'channelId',
  CLIP_ID: 'clipId',
  COLLECTION_ID: 'collectionId',
  CONTENT_REGION_ID: 'contentRegionId',
  DATAOBJECT_ID: 'dataobjectId',
  DATASTREAM_ID: 'datastreamId',
  DRM_PROVIDER_ID: 'drmProviderId',
  ENTITY_ID: 'entityId',
  ENVIRONMENT_ID: 'environmentId',
  ENTRY_ID: 'entryId',
  EVENT_ID: 'eventId',
  EVENT_SESSION_ID: 'sessionId',
  EXP_APP_ID: 'expAppId',
  EXP_MANIFEST_ID: 'expManifestId',
  EXTERNAL_STORE_ID: 'externalStoreId',
  GATEWAY_ID: 'gatewayId',
  GLOBAL_AUDIO_ID: 'globalAudioId',
  IMAGE_ID: 'imageId',
  INGEST_TASK_ID: 'ingestTaskId',
  INSTANCE_ID: 'instanceId',
  INVITATION_ID: 'invitationId',
  MANAGED_STORE_ID: 'managedStoreId',
  MEDIA_CHANNEL_ENTRY_ID: 'mediaChannelEntryId',
  MEDIA_CHANNEL_ID: 'mediaChannelId',
  MEDIA_ID: 'mediaId',
  MEDIA_LIBRARY_ID: 'mediaLibraryId',
  MOMENT_ID: 'momentId',
  OBJECT_ID: 'objectId',
  OFFER_ID: 'offerId',
  ORGANIZATION_ID: 'organizationId',
  ORIGIN_ID: 'originId',
  PAGE_ID: 'pageId',
  PLATFORM_ID: 'platformId',
  PROGRAM_ID: 'programId',
  RESERVATION_ID: 'reservationId',
  SECTION_ID: 'sectionId',
  SHORT_ID: 'shortId',
  SHOWCASE_ID: 'showcaseId',
  SPACE_ID: 'spaceId',
  STORE_ID: 'storeId',
  STREAM_ID: 'streamId',
  TEAM_ID: 'teamId',
  VIDEO_ID: 'videoId',
  VIDEO_TRACK_ID: 'videoTrackId',
  VIDEOOBJECT_ID: 'videoobjectId',
  VIDEOSTREAM_ID: 'videostreamId',
  WORKSPACE_ID: 'workspaceId',
} as const

export const DynamicRouteParameterWPrefix = Object.entries(DynamicRouteParameter).reduce(
  (acc, item) => ({ ...acc, [item[0]]: `$${item[1]}` }) as const,
  {} as { [key in keyof typeof DynamicRouteParameter]: `$${(typeof DynamicRouteParameter)[key]}` },
)
